import { useEffect, useState } from 'react';

// react-native-keyboard-controller is a no-op on web (its web binding stubs every
// native call and renders a plain View), so KeyboardAwareScrollView does not dodge
// there. Derive the keyboard overlap from the VisualViewport API, which iOS Safari
// and Android Chrome both shrink when the soft keyboard opens. Returns 0 on desktop
// (no soft keyboard) and whenever the keyboard is closed.
export function useKeyboardInset(): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.visualViewport) {
      return;
    }
    const viewport = window.visualViewport;

    const update = () => {
      if (viewport.scale > 1.01) {
        setInset(0);
        return;
      }
      const overlap = window.innerHeight - viewport.height;
      setInset(Math.max(0, Math.round(overlap)));
    };

    update();
    viewport.addEventListener('resize', update);
    return () => {
      viewport.removeEventListener('resize', update);
    };
  }, []);

  return inset;
}
